import { Badge } from '@repo/shadcn';
import { FC } from 'react';

type ActiveStatusBadgeProps = {
    isActive: boolean;
};
export const ActiveStatusBadge: FC<ActiveStatusBadgeProps> = ({
    isActive,
}: {
    isActive: boolean;
}) => {
    if (isActive) {
        return <Badge className={'bg-green-600 uppercase'}>Active</Badge>;
    }

    return (
        <Badge variant={'destructive'} className={'uppercase'}>
            Suspended
        </Badge>
    );
};

ActiveStatusBadge.displayName = 'ActiveStatusBadge';
